import React from 'react';
import { useBreakpointMatch } from 'src/hooks/useBreakpoint';

import { usePopupBanner } from './usePopupBanner';
import classes from './PopupBanner.scss';

export const PopupBanner: React.FC = () => {
    const { popup, isOpen, showRibbon, isProductPage, dismiss, reopen } = usePopupBanner();
    const { isMob } = useBreakpointMatch();

    if (!popup) return null;
    if (isMob && isProductPage) return null;

    const imageSrc = isMob ? popup.imageMobile : popup.imageDesktop;

    return (
        <>
            {isOpen && (
                <div className={classes.overlay} onClick={dismiss} data-test-id="PopupBannerOverlay">
                    <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
                        <button
                            className={classes.closeButton}
                            onClick={dismiss}
                            aria-label="Close popup"
                            type="button"
                        >
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M13 1L1 13M1 1l12 12"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                        <a href={popup.link} className={classes.imageLink} onClick={dismiss}>
                            <img src={imageSrc} alt={popup.title} className={classes.image} loading="lazy" />
                        </a>
                    </div>
                </div>
            )}

            {showRibbon && (
                <button className={classes.ribbon} onClick={reopen} type="button" data-test-id="PopupBannerRibbon">
                    <span className={classes.ribbonText}>{isMob ? 'Reveal Discount' : `Reveal ${popup.title}`}</span>
                </button>
            )}
        </>
    );
};
